<div #sentinel class="back-to-top-sentinel" aria-hidden="true"></div>

<button
  type="button"
  class="btn btn-alt-secondary shadow d-inline-flex flex-column align-items-center justify-content-center fw-bold text-center back-to-top-button"
  [class.back-to-top-button-visible]="visible"
  [class.pe-auto]="visible"
  [disabled]="!visible"
  [attr.aria-hidden]="visible ? null : 'true'"
  [attr.tabindex]="visible ? null : -1"
  aria-label="Back to top of page"
  (click)="scrollToTop()"
>
  <span class="material-icons-round" aria-hidden="true">arrow_upward</span>
  <span>Back</span>
  <span>to Top</span>
</button>
